import { styled } from '@material-ui/core/styles';
import CalendarIcon from '../Icons/CalendarIcon';

const StyledCalendarIcon = styled(CalendarIcon)({
  width: 13, height: 14,
});

export default StyledCalendarIcon;
